<template>
  <v-app id="app">
    <v-navigation-drawer permanent app clipped v-if="creatorSidebar" elevation=0>
      <v-container class="pa-0">
      <v-row class="pt-3">
      <v-col>
        <v-badge
          :key="getMe ? getMe.id : 0"
          class="avatar-badge"
          color="green"
          avatar
          bottom
          icon="mdi-lead-pencil"
          overlap
          :value="isCreator"
          offset-x="20"
          offset-y="20"
        >
          <Avatar :userProfile="getMe.userProfile" />
        </v-badge>
      </v-col>
      </v-row>
      <v-row no-gutters>
      <v-col v-if="getMe.userProfile && getMe.userProfile.username"> @{{ getMe.userProfile.username }}</v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <v-row no-gutters>
      <v-col>
        <v-list dense nav class="pa-0">
          <v-list-item to="/creator-dashboard" class="rounded-0">
            <v-list-item-icon>
              <v-icon>mdi-monitor-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('creator.dashboard.dashboard') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      </v-row>
      </v-container></v-navigation-drawer>
    <v-app-bar app clipped-left permanent>
      <router-link to="/">
        <v-img
          :src="require('@/assets/logo.svg')"
          contain
          max-width="60"
          height="60"
        />
      </router-link>
      <v-spacer />
      <CreateStoryButton v-if="isCreator" />
      <router-link
        v-if="isCreator"
        class="black--text mx-10"
        style="text-decoration: none"
        to="/creator-dashboard"
        >{{ $t("creator.creatorMenu") }}</router-link
      >
      <v-btn v-if="!getMe" color="primary" class="mx-10" to="/auth/sign-in">
        {{ $t("login.loginNoun") }}
      </v-btn>
      <v-menu bottom min-width="200px" v-if="getMe" rounded offset-y>
        <template v-slot:activator="{ on }">
          <v-badge
            :key="getMe ? getMe.id : 0"
            class="avatar-badge"
            color="green"
            avatar
            bottom
            icon="mdi-lead-pencil"
            overlap
            :value="isCreator"
            offset-x="20"
            offset-y="20"
          >
            <v-btn icon v-on="on">
              <Avatar :userProfile="getMe.userProfile" />
            </v-btn>
          </v-badge>
        </template>
        <v-card v-if="getMe">
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-badge
                :key="getMe ? getMe.id : 0"
                class="avatar-badge"
                color="green"
                avatar
                bottom
                icon="mdi-lead-pencil"
                overlap
                :value="isCreator"
                offset-x="20"
                offset-y="20"
              >
                <Avatar :userProfile="getMe.userProfile" />
              </v-badge>
              <h3 v-if="getMe.userProfile">
                {{
                  $t("fullName", {
                    firstName: getMe.userProfile.firstName,
                    lastName: getMe.userProfile.lastName,
                  })
                }}
              </h3>
              <p class="text-caption mt-1">
                {{ getMe.email }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded text @click="logout">
                {{ $t("login.logOutVerb") }}
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-container
      fluid
      :class="creatorSidebar ? 'main-container sidebar' : 'main-container'"
    >
      <router-view />
    </v-container>
    <v-alert
      dense
      v-if="nodeEnv != 'production'"
      color="blue-grey"
      style="position: fixed; bottom: 0; right: 2px; z-index: 1337"
    >
      <a style="color: white" :href="buildLink"
        >Client Build: {{ buildNumber }}</a
      ><br />
      <span v-if="serverInfo" style="color: white"
        >Server Version: {{ serverInfo.version }}</span
      >
    </v-alert>
  </v-app>
</template>
<script>
import gql from "graphql-tag";
import { mapGetters, mapMutations } from "vuex";
import Avatar from "@/components/User/Avatar";
import CreateStoryButton from "@/components/CreatorTools/CreateStoryButton";
export default {
  components: {
    Avatar,
    CreateStoryButton,
  },
  apollo: {
    serverInfo: {
      query: gql`
        query {
          serverInfo {
            version
            id
          }
        }
      `,
      update(data) {
        return data.serverInfo;
      },
    },
  },
  computed: {
    creatorSidebar() {
      for (const matchedRoute of this.$route.matched) {
        if (matchedRoute && matchedRoute.meta && matchedRoute.meta.creatorSidebar) {
          return true 
        }
      }
      return false
    },
    buildNumber() {
      return process.env.VUE_APP_BUILD_NUMBER;
    },
    buildLink() {
      return process.env.VUE_APP_BUILD_LINK;
    },
    nodeEnv() {
      return process.env.NODE_ENV;
    },
    ...mapGetters("auth", ["getMe", "isCreator"]),
  },
  methods: {
    ...mapMutations("auth", ["setMe"]),
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      this.$router.push("/auth/sign-in");
      this.setMe(null);
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: var(--v-background-base);
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.main-container {
  margin-top: 5em;
}
.sidebar {
  padding-left: 16em;
}
.v-list .v-list-item--active {
  border-left: 5px solid var(--v-primary-base);
}
</style>
